import { AbstractBoardLane } from './abstract-board-lane.model';

export class BoardLaneCreator extends AbstractBoardLane {}
